import { render, staticRenderFns } from "./individualPersonality.vue?vue&type=template&id=66e8cff4&scoped=true"
import script from "./individualPersonality.vue?vue&type=script&lang=js"
export * from "./individualPersonality.vue?vue&type=script&lang=js"
import style0 from "./individualPersonality.vue?vue&type=style&index=0&id=66e8cff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e8cff4",
  null
  
)

export default component.exports